import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class NavigationHelpService {
    constructor(private _router: Router) {}

    navigateTo(routerLink: Array<string>, queryParams: object, addNavFromUrl = false) {
        if (addNavFromUrl) {
            let navFromUrl = this._router.url.split('?')[0];
            queryParams = this.setPreviousUrlToQuarryParams(queryParams, navFromUrl);
        }
        this._router.navigate(routerLink, {
            queryParams: queryParams,
        });
    }

    setPreviousUrlToQuarryParams(queryParams: object, navFromUrl: string) {
        try {
            if (queryParams && !queryParams['navFromUrl']) {
                queryParams['navFromUrl'] = navFromUrl;
            } else if (!queryParams) {
                queryParams = { navFromUrl: navFromUrl };
            }
            return queryParams;
        } catch (error) {
            return queryParams; /*throw error*/
        }
    }
}
